import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { modalGenericStyles, variables } from "../../../../../variables";
import { toast } from "react-toastify";
import GenericBasicInfo from "../../../../../components/cards/GenericBasicInfo";
import Loader from "../../../../../components/Loader/index";
import { deleteWebSitePromoLandingPage } from "../../../../../api/DistributionSite/webSites/PromoLandingPages";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { genericRequestErrorHandler } from "../../../../../api";
import _ from "lodash";
import { CustomButton } from "../../../../../components/CustomButton";

const basicDataCpl = [
  ["Id", "id"],
  ["Name", "name"],
  ["Page Type", "page_type"],
  ["Title", "title"],
  ["Video Position", "video_position"],
  ["Video Url", "video_url"],
];

const styles = createUseStyles({
  ...modalGenericStyles,
  DeletePromoLandingPage: {
    ...modalGenericStyles.modal,
    display: "grid",
    gridGap: variables.normal_gap,
  },
  basicInfo: {
    display: "grid",
    gridGap: variables.normal_gap,
    justifyContent: "center",
  },
});
const DeletePromoLandingPage = ({ id, data, onClose }) => {
  const classes = styles();

  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: ({ id }) =>
      deleteWebSitePromoLandingPage({
        id: id,
      }),
    onSuccess: () => {
      toast.success("Promo Landing Page Deleted");
      queryClient.invalidateQueries("PromoLandingPages");
      onClose();
    },
    onError: (error) => genericRequestErrorHandler(error),
  });

  const onDelete = (id) => {
    deleteMutation.mutate({ id });
  };

  return (
    <div className={classes.DeletePromoLandingPage}>
      {deleteMutation.isLoading && <Loader onTop={true} />}
      <div className={classes.card}>
        <div className={classes.cardHeader}>
          <span>DELETE Promo Landing Page</span>
        </div>
        <div className={classes.cardBody}>
          <div className={classes.basicInfo}>
            <GenericBasicInfo
              header={"Are you sure you want to delete this?"}
              cardInfo={basicDataCpl}
              objectData={data}
            />
          </div>
        </div>
        <div className={classes.cardActions}>
          <CustomButton appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
          <CustomButton appearance="primary" onClick={() => onDelete(id)}>
            <strong>DELETE</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DeletePromoLandingPage.propTypes = {
  id: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DeletePromoLandingPage;
